<!-- 视频播放弹窗 -->
<template>
  <el-dialog
    custom-class="dnn-video-modal"
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    :close-on-press-modal="false"
    width="900px"
    :before-close="handleClose"
  >
    <video controls :poster="video.cover" :src="video.videoUrl"></video>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    video: {
      type: Object,
      default: () => {
        // 目前只用到封面和视频地址字段
        return {
          id: "",
          title: "",
          desc: "",
          cover: "",
          videoUrl: "",
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>

<style lang="scss">
.el-dialog__wrapper {
  background: rgba(11, 11, 11, 0.8);
}
.dnn-video-modal {
  background: transparent;
  border: none;
  box-shadow: none;
  .el-dialog__header {
    background: transparent;
  }
  .el-dialog__body {
    padding: 0;
    height: 500px;
    background: #000;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 5px;
    right: 0;
    .el-dialog__close {
      font-weight: bolder;
      font-size: 24px;
    }
  }
}
</style>
